const BUTTON_VARIANTS = ['primary', 'secondary', 'outlined-dark', 'outlined-light', 'text', 'alternate'];

export const config = {
    name: 'Footer Hook SB',
    inputs: [
        {
            name: 'headline',
            type: 'string',
            required: true,
            defaultValue: 'Imagine your team with Storyblocks for Business',
        },
        {
            name: 'paragraph',
            type: 'longText',
            required: true,
            defaultValue:
                'Take the first step in leveling up your team’s creative process and get ahead of the competition by requesting a personalized quote today.',
        },
        {
            name: 'shadowVariant',
            type: 'boolean',
            defaultValue: false,
        },
        {
            name: 'shadowOptions',
            type: 'object',
            showIf: (options) => options.get('shadowVariant'),
            defaultValue: {
                shadowColor: 'var(--color-gray-100, #f5f5f5)',
                shadowImage: '',
            },
            subFields: [
                {
                    name: 'shadowColor',
                    type: 'color',
                },
                {
                    name: 'shadowImage',
                    type: 'file',
                    allowedFileTypes: ['jpg', 'jpeg', 'png', 'webp'],
                },
            ],
        },
        {
            name: 'showCallToAction',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'callToAction',
            type: 'object',
            defaultValue: {
                text: 'Explore Footage',
                href: '/',
                variant: BUTTON_VARIANTS[5],
                size: 'default',
                target: '_self',
                rel: '',
            },
            showIf: (options) => options.get('showCallToAction'),
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    default: '',
                    required: true,
                },
                {
                    name: 'href',
                    type: 'string',
                    default: '/',
                    required: true,
                },
                {
                    name: 'target',
                    type: 'string',
                    enum: ['_self', '_blank', '_parent', '_top'],
                    helperText:
                        'For explanation of options, see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target',
                },
                {
                    name: 'variant',
                    type: 'string',
                    default: BUTTON_VARIANTS[5],
                    enum: BUTTON_VARIANTS,
                },
            ],
        },
    ],
};
